import { createTransform } from "redux-persist";
import {
  initialCheckoutV2State,
  sanitizeCheckoutV2State,
} from "./reducer";

// Quotes are short-lived server attestations. Persist the shopper's safe
// checkout draft and payment-attempt identity, then always obtain a fresh
// quote after reload instead of reviving an expired quote id or totals.
export const sanitizeCheckoutV2PersistedState = (state = {}) => {
  const sanitized = sanitizeCheckoutV2State(state);
  let fulfillmentContext = sanitized.fulfillmentContext;
  if (fulfillmentContext?.time) {
    const { authority, ...safeTime } = fulfillmentContext.time;
    fulfillmentContext = { ...fulfillmentContext, time: safeTime };
  }
  return {
    ...sanitized,
    fulfillmentContext,
    quote: null,
  };
};

export const checkoutV2PersistTransform = createTransform(
  (state) => sanitizeCheckoutV2PersistedState(state),
  (state) => sanitizeCheckoutV2PersistedState(state),
  { whitelist: ["checkoutV2"] },
);

export const migrateCheckoutV2State = (state = {}) => ({
  ...state,
  checkoutV2: sanitizeCheckoutV2PersistedState(
    state.checkoutV2 || initialCheckoutV2State,
  ),
});
